<c-container class="beta-activation-container py-4" fluid>
  <c-row class="justify-content-center">
    <c-col xs="12" md="8" lg="6">
      <!-- Loading -->
      @if (step() === 'loading') {
        <div class="text-center py-5">
          <c-spinner color="primary"></c-spinner>
        </div>
      }

      <!-- Main card (all other states) -->
      @if (step() !== 'loading') {
        <c-card>
          <c-card-header>
            <strong>{{ 'beta_page_title' | translate }}</strong>
          </c-card-header>

          <c-card-body>
            <!-- No cards -->
            @if (step() === 'no-cards') {
              <c-alert color="secondary">
                <i cIcon name="cilInfo" class="me-2"></i>
                {{ 'beta_no_cards' | translate }}
              </c-alert>
            }

            <!-- Already active -->
            @if (step() === 'already-active' && betaCard(); as card) {
              <c-alert color="success">
                <strong>{{ 'beta_already_active_title' | translate }}</strong>
              </c-alert>
              <p>
                {{
                  'beta_already_active_message' | translate: {
                    cardNumber: card.card_number,
                    cardType: getCardTypeLabel(card.card_type)
                  }
                }}
              </p>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-dark fs-6">#{{ card.card_number }}</span>
                <c-badge [color]="getCardTypeBadgeColor(card.card_type)">
                  {{ getCardTypeLabel(card.card_type) }}
                </c-badge>
                <c-badge color="success">BETA</c-badge>
              </div>
              <div class="mt-4">
                <a cButton color="primary" [routerLink]="['/', lang, 'dashboard']">
                  {{ 'beta_go_to_dashboard' | translate }}
                </a>
              </div>
            }

            <!-- Select step -->
            @if (step() === 'select') {
              <p class="text-muted mb-3">{{ 'beta_page_subtitle' | translate }}</p>
              <div class="table-responsive">
                <table cTable hover striped>
                  <thead>
                    <tr>
                      <th style="width: 2rem;"></th>
                      <th>{{ 'beta_card_number' | translate }}</th>
                      <th>{{ 'beta_card_type' | translate }}</th>
                      <th class="text-end">{{ 'beta_card_balance' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (card of userCards(); track card.id) {
                      <tr
                        (click)="selectCard(card.id)"
                        style="cursor: pointer;"
                        [class.table-active]="selectedCardId() === card.id"
                      >
                        <td>
                          <input
                            type="radio"
                            [checked]="selectedCardId() === card.id"
                            (change)="selectCard(card.id)"
                            style="cursor: pointer;"
                          />
                        </td>
                        <td><span class="badge bg-dark">#{{ card.card_number }}</span></td>
                        <td>
                          <c-badge [color]="getCardTypeBadgeColor(card.card_type)">
                            {{ getCardTypeLabel(card.card_type) }}
                          </c-badge>
                        </td>
                        <td class="text-end">{{ card.balance | number: '1.2-2' }} USD</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="mt-3 text-end">
                <button
                  cButton
                  color="primary"
                  [disabled]="!selectedCardId()"
                  (click)="confirmActivation()"
                >
                  {{ 'beta_activate_button' | translate }}
                </button>
              </div>
            }

            <!-- Confirm step -->
            @if (step() === 'confirm' && selectedCard(); as card) {
              <c-alert color="warning">
                <strong>{{ 'beta_confirm_title' | translate }}</strong><br>
                {{
                  'beta_confirm_warning' | translate: { cardNumber: card.card_number }
                }}
              </c-alert>
              <div class="d-flex gap-2 justify-content-end mt-3">
                <button
                  cButton
                  color="secondary"
                  variant="outline"
                  [disabled]="saving()"
                  (click)="cancelConfirm()"
                >
                  {{ 'beta_confirm_cancel' | translate }}
                </button>
                <button
                  cButton
                  color="danger"
                  [disabled]="saving()"
                  (click)="activateBeta()"
                >
                  @if (saving()) {
                    <c-spinner size="sm" class="me-1"></c-spinner>
                  }
                  {{ 'beta_confirm_yes' | translate }}
                </button>
              </div>
            }

            <!-- Success -->
            @if (step() === 'success' && betaCard(); as card) {
              <c-alert color="success">
                <strong>{{ 'beta_success_title' | translate }}</strong><br>
                {{
                  'beta_success_message' | translate: { cardNumber: card.card_number }
                }}
              </c-alert>
              <div class="d-flex align-items-center gap-2 mt-2">
                <span class="badge bg-dark fs-6">#{{ card.card_number }}</span>
                <c-badge [color]="getCardTypeBadgeColor(card.card_type)">
                  {{ getCardTypeLabel(card.card_type) }}
                </c-badge>
                <c-badge color="success">BETA</c-badge>
              </div>
            }

            <!-- Error -->
            @if (step() === 'error') {
              <c-alert color="danger">
                <strong>{{ 'beta_error_title' | translate }}</strong>
                @if (errorMessage()) {
                  <p class="mb-0 mt-1">{{ errorMessage() }}</p>
                }
              </c-alert>
            }
          </c-card-body>
        </c-card>
      }
    </c-col>
  </c-row>
</c-container>